import React, { useState } from "react";
import emailjs from "emailjs-com"; // Import Email.js SDK

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [status, setStatus] = useState("");
  const [isSending, setIsSending] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSending(true);
    setStatus("");

    try {
      // Template parameters for your email
      const userMessageParams = {
        from_name: formData.name,
        from_email: formData.email,
        to_name: "Adaeze Ugwumba",
        message: formData.message,
        to_email: "adaezeugwumba460@gmail.com",
      };

      // Template parameters for the automatic reply
      const autoReplyParams = {
        from_name: "Your App Name",
        to_name: formData.name,
        to_email: formData.email,
        message: `
          Hi ${formData.name},
          
          Thank you for your interest in our app! 

          - If you're new, please select your user type [insert link] and register.
          - If you're already a user, log in here as a buyer [insert link] or log in here as a pharmacist [insert link]

          If you have any feedback or questions, feel free to reach out—we're here to help!

          Best regards,
          Your App Team
        `,
      };

      // Send the user's message to you
      await emailjs.send(
        "service_bklt76g", // Replace with your service ID
        "template_f31k0r9", // Replace with your template ID
        userMessageParams,
        "RryaS-GOW6wPkvhCY" // Replace with your public key (user ID)
      );

      // Send the automatic reply to the user
      await emailjs.send(
        "service_bklt76g", // Same service ID
        "template_f31k0r9", // Replace with your auto-reply template ID
        autoReplyParams,
        "RryaS-GOW6wPkvhCY" // Same public key (user ID)
      );

      setStatus(
        "Message sent successfully! A confirmation email has been sent to your inbox."
      );
      setFormData({ name: "", email: "", message: "" }); // Clear the form
    } catch (error) {
      console.error("Error sending email:", error);
      setStatus("Failed to send message. Please try again later.");
    } finally {
      setIsSending(false);
    }
  };

  return (
    <section id="contact" className="py-16">
      <div className="container mx-auto px-6 text-center">
        <h2 className="text-3xl font-semibold">Contact Us</h2>
        <p className="mt-4 text-lg">
          Have any questions? Reach out to us, and we’ll be happy to assist.
        </p>
        <form className="mt-6 space-y-4" onSubmit={handleSubmit}>
          <div>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:border-blue-500"
              required
            />
          </div>
          <div>
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:border-blue-500"
              required
            />
          </div>
          <div>
            <textarea
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:border-blue-500"
              rows="4"
              required
            />
          </div>
          <button
            type="submit"
            disabled={isSending}
            className={`px-8 py-3 rounded-lg text-white ${
              isSending ? "bg-gray-400" : "bg-green-400 hover:bg-green-700"
            }`}
          >
            {isSending ? "Sending..." : "Send Message"}
          </button>
        </form>
        {status && (
          <p
            className={`mt-4 text-sm ${
              status.includes("successfully")
                ? "text-green-600"
                : "text-red-600"
            }`}
          >
            {status}
          </p>
        )}
      </div>
    </section>
  );
};

export default Contact;
